import React from 'react';

import { Button, DatePicker, Form, Modal } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { t } from 'i18next';

import { useAppSelector, useNotification } from 'segments/hooks';

import { usePayUserGroupeMutation } from 'features/users';
import { selectActiveUserId } from 'features/users/store/usersSlice';

interface FormValues {
  dates: Dayjs[];
}

type Props = {
  handleCancel: () => void;
};

const today = dayjs();
export const GroupePayment = (props: Props) => {
  const {
    handleCancel,
  } = props;

  const selectedUserId = useAppSelector(selectActiveUserId);
  const [payForGroupe, { isLoading, isSuccess, isError, error }] = usePayUserGroupeMutation();
  const [form] = Form.useForm();


  useNotification({
    isSuccess,
    isError,
    error,
    onSuccess: () => {
      handleCancel();
      form.resetFields();
    },
  });


  if (selectedUserId === null) {
    return;
  }

  const onFinish = ({ dates }: FormValues) => {
    dates.forEach((date) => {
      payForGroupe({
        userId: selectedUserId,
        date
      });
    });
  };

  return (
    <Modal
      open
      title={t('user.groupe-payment')}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={{
          date: [today]
        }}
        disabled={isLoading}
      >
        <Form.Item
          label={t('form-items.select.multi-month')}
          name='dates'
          rules={[{ required: true }]}
        >
          <DatePicker
            multiple
            maxTagCount="responsive"
            picker='month'
          />
        </Form.Item>
        <Button type="primary" htmlType="submit" className="login-form-button">
          {t('user.go', 'Выполнить')}
        </Button>
      </Form>
    </Modal >
  );
};
